import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { guardPortalV2Route } from '../../../util/portalV2';

/**
 * Soft-launch entry for non-subscribers.
 * Single shell: redirect into DashboardV2 limited mode (userTypeId === 4).
 * Keeps /nonSubscriber-v2 as the login destination without a separate UI.
 */
const NonSubscriberV2 = () => {
    const history = useHistory();

    useEffect(() => {
        if (!guardPortalV2Route(history, '/NonSubscriber')) return;
        history.replace('/dashboard-v2');
    }, [history]);

    return null;
};

export default NonSubscriberV2;
